<template>
  <div class="scrollbar">
    <loader
      :pageloader_value="pageLoader"
      :type="'complete'"
      v-if="pageLoader"
    ></loader>
    <message
      :message="response_msg"
      :messageType="msg_type"
      v-if="response_msg != ''"
    ></message>
    <div class="col-12 inMiddle-area mt-2">
      <div class="row">
        <div
          class="col-12"
          v-if="
            dashboardData.length > 0 &&
            dashboardData[0].hasOwnProperty('dashboardData') &&
            dashboardData[0].dashboardData &&
            Object.keys(dashboardData[0].dashboardData).length > 0
          "
        >
          <div class="row">
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="users" size="17px"></feather>
                    </div>
                    <div class="card-item-title mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0"
                        >Total Clients</label
                      >
                      <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-html="
                            dashboardData[0].dashboardData.total_client != '' &&
                            dashboardData[0].dashboardData.total_client != null
                              ? dashboardData[0].dashboardData.total_client
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="airplay" size="17px"></feather>
                    </div>
                    <div class="card-item-title d-flex align-items-center mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0 mr-2"
                        >New Clients</label
                      >
                      <span class="d-block tx-12 mb-0 text-muted">7 Days</span>
                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-html="
                            dashboardData[0].lastWeekClient != '' &&
                            dashboardData[0].lastWeekClient != null
                              ? dashboardData[0].lastWeekClient
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="check-circle" size="17px"></feather>
                    </div>
                    <div class="card-item-title mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0"
                        >Verified Clients</label
                      >
                      <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-html="
                            dashboardData[0].dashboardData.verified_client !=
                              '' &&
                            dashboardData[0].dashboardData.verified_client !=
                              null
                              ? dashboardData[0].dashboardData.verified_client
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="card custom-card border-0">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-icon card-icon">
                      <feather type="archive" size="17px"></feather>
                    </div>
                    <div class="card-item-title mb-3">
                      <label
                        class="main-content-label tx-13 font-weight-bold mb-0"
                        >Funded Clients</label
                      >
                      <!-- <span class="d-block tx-12 mb-0 text-muted">Previous month vs this months</span>  -->
                    </div>
                    <div class="card-item-body">
                      <div class="card-item-stat">
                        <h4
                          class="font-weight-bold"
                          v-html="
                            dashboardData[0].dashboardData.total_funded != '' &&
                            dashboardData[0].dashboardData.total_funded != null
                              ? dashboardData[0].dashboardData.total_funded
                              : 0
                          "
                        ></h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-12 space rightFilterSearch"
          v-if="
            dashboardData.length > 0 &&
            dashboardData[0].hasOwnProperty('dashboardData') &&
            dashboardData[0].dashboardData &&
            Object.keys(dashboardData[0].dashboardData).length > 0
          "
        >
          <div class="selectFilter-type d-flex justify-content-between">
            <ul class="tableFilDate d-flex align-items-center">
              <li
                @click.prevent="
                  selectKey = 0;
                  listing();
                "
                :class="selectKey == 0 ? 'active' : ''"
              >
                All
                <sub
                  v-html="
                    dashboardData[0].dashboardData.total_client != '' &&
                    dashboardData[0].dashboardData.total_client != null
                      ? dashboardData[0].dashboardData.total_client
                      : 0
                  "
                ></sub>
              </li>

              <li
                @click.prevent="
                  selectKey = 1;
                  listing();
                "
                :class="selectKey == 1 ? 'active' : ''"
              >
                Verified
                <sub
                  v-html="
                    dashboardData[0].dashboardData.verified_client != '' &&
                    dashboardData[0].dashboardData.verified_client != null
                      ? dashboardData[0].dashboardData.verified_client
                      : 0
                  "
                ></sub>
              </li>

              <li
                @click.prevent="
                  selectKey = 2;
                  listing();
                "
                :class="selectKey == 2 ? 'active' : ''"
              >
                Unverified
                <sub
                  v-html="
                    dashboardData[0].dashboardData.total_client != '' &&
                    dashboardData[0].dashboardData.total_client != null
                      ? dashboardData[0].dashboardData.total_client -
                        dashboardData[0].dashboardData.verified_client
                      : 0
                  "
                ></sub>
              </li>

              <li
                @click.prevent="
                  selectKey = 3;
                  depositListing();
                "
                :class="selectKey == 3 ? 'active' : ''"
              >
                Funded
                <sub
                  v-html="
                    dashboardData[0].dashboardData.total_funded != '' &&
                    dashboardData[0].dashboardData.total_funded != null
                      ? dashboardData[0].dashboardData.total_funded
                      : 0
                  "
                ></sub>
              </li>

              <li
                @click.prevent="
                  selectKey = 4;
                  listing();
                "
                :class="selectKey == 4 ? 'active' : ''"
              >
                Closed <sub>---</sub>
              </li>
            </ul>
            <app-top-header-title ref="form"></app-top-header-title>
          </div>
        </div>
        <div class="col-12">
          <div class="whiteBG box-shadow">
            <div
              class="tableHead-title d-flex align-items-center justify-content-between mb-2"
            >
              <label class="font-weight-bold"> List</label>
              <div class="rtl d-flex align-items-center">
                <ul class="selectmotr d-flex align-items-center">
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'd' ? 'active' : '']"
                      @click.prevent="eventInterValFl('d', 'stat')"
                      >Day</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'm' ? 'active' : '']"
                      @click.prevent="eventInterValFl('m', 'stat')"
                      >Month</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == 'y' ? 'active' : '']"
                      @click.prevent="eventInterValFl('y', 'stat')"
                      >Year</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[statInfo.interval == '' ? 'active' : '']"
                      @click.prevent="eventInterValFl('', 'stat')"
                      >All</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      v-bind:class="[
                        statInfo.interval == 'custom' ? 'active' : '',
                      ]"
                      @click.prevent="openToggle = !openToggle"
                      >Custom</a
                    >
                    <div class="mainFilterBytime modHalf">
                      <div
                        class="cutDropdown pt-0 px-0 pb-4"
                        :class="openToggle ? 'active' : ''"
                      >
                        <ul class="datPickerT">
                          <li
                            class="headTitle d-flex align-items-center justify-content-between"
                          >
                            <span>Select Date</span>
                          </li>
                          <li class="d-flex align-items-center p-3">
                            <div
                              class="mx-datepicker form-control whiteBG pt-0"
                            >
                              <label>From</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.from"
                                name="dob1"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.from != '' &&
                                  statInfo.from != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div class="mx-datepicker">
                              <label>To</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.to"
                                name="dob2"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class="
                                  (statInfo.to != '' &&
                                  statInfo.to != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                      submittedRequest && errors.has('dob'),
                                  }
                                "
                                :disabled="disable"
                              />
                            </div>
                            <div
                              class="closeIcon"
                              @click.prevent="
                                openToggle = !openToggle;
                                statInfo.from = '';
                              "
                            >
                              <feather type="x"></feather>
                            </div>
                          </li>
                          <li class="px-3 pt-3">
                            <a
                              href="#"
                              @click.prevent="eventInterValFl('custom', 'stat')"
                              class="grd_btn greenBG"
                              >Submit</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="download-table-data ml-3">
                  <a
                    title="Download Data"
                    @click.prevent="
                      csvExport(
                        userList.records,
                        'client_commission',
                        'client_commission.csv'
                      )
                    "
                    ><img
                      src="../../../../static/fxView/images/excel.png"
                      alt="Icon"
                  /></a>
                </div>
              </div>
            </div>
            <div class="scrollable-x">
              <table class="table table-striped focus-on clientLst-table">
                <!-- {{ userList }} -->
                <thead>
                  <tr>
                    <th>Registration Date</th>
                    <th>Name</th>
                    <!-- <th>Email</th> -->
                    <th>Country</th>
                    <th>Sub-Affiliate</th>
                    <th>Traded Volume</th>
                    <th>Total Revenue</th>
                    <th>Sub-Affiliate Comm.</th>
                    <th>My Comm.</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody v-if="selectKey != 3">
                  <!-- {{ userList }} -->
                  <tr
                    v-for="(list, index) in userList.records"
                    v-if="
                      userList.records.length > 0 && userList.totalRecords > 0
                    "
                  >
                    <td
                      v-html="
                        list.created != '' && list.created != null
                          ? getHumanDate(list.created)
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="list.username || 'New User'"
                    ></td>
                    <!-- <td v-html="(list.email != '' && list.email != null) ? list.email : '-'"></td> -->
                    <td
                      v-html="
                        list.country != '' && list.country != null
                          ? list.country
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        get_user.id != list.admin_id &&
                        list.RMname != '' &&
                        list.RMname != null
                          ? list.RMname
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.totalVolume != '' && list.totalVolume != null
                          ? list.totalVolume
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.totalRevenue != '' && list.totalRevenue != null
                          ? list.totalRevenue
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.subIbCommission != '' &&
                        list.subIbCommission != null
                          ? list.subIbCommission
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.myCommission != '' && list.myCommission != null
                          ? list.myCommission
                          : '-'
                      "
                    ></td>
                    <td
                      class="funded"
                      v-html="list.status == 1 ? 'Active' : 'Inactive'"
                    >
                      Funded
                    </td>
                  </tr>
                  <tr class="noDataFound" v-if="userList.totalRecords == 0">
                    <td colspan="10">
                      <loader
                        :pageloader_value="pageLoader"
                        :type="'table'"
                        :colspan="col_span"
                        :list="userList"
                        v-if="pageLoader == false"
                      ></loader>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="selectKey == 3">
                  <tr
                    v-for="(list, index) in depositList.records"
                    v-if="
                      depositList.records.length > 0 &&
                      depositList.totalRecords > 0
                    "
                  >
                    <td
                      v-html="
                        list.created != '' && list.created != null
                          ? getHumanDate(list.created)
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.firstname != '' && list.firstname != null
                          ? list.firstname
                          : '-'
                      "
                    ></td>
                    <!-- <td v-html="(list.email != '' && list.email != null) ? list.email : '-'"></td> -->
                    <td
                      v-html="
                        list.country != '' && list.country != null
                          ? list.country
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        get_user.id != list.admin_id &&
                        list.RMname != '' &&
                        list.RMname != null
                          ? list.RMname
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.totalVolume != '' && list.totalVolume != null
                          ? list.totalVolume
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.totalRevenue != '' && list.totalRevenue != null
                          ? list.totalRevenue
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.subIbCommission != '' &&
                        list.subIbCommission != null
                          ? list.subIbCommission
                          : '-'
                      "
                    ></td>
                    <td
                      v-html="
                        list.myCommission != '' && list.myCommission != null
                          ? list.myCommission
                          : '-'
                      "
                    ></td>
                    <td
                      class="funded"
                      v-html="list.status == 1 ? 'Active' : 'Inactive'"
                    >
                      Funded
                    </td>
                  </tr>
                  <tr class="noDataFound" v-if="depositList.totalRecords == 0">
                    <td colspan="10">
                      <loader
                        :pageloader_value="pageLoader"
                        :type="'table'"
                        :colspan="col_span"
                        :list="depositList"
                        v-if="pageLoader == false"
                      ></loader>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <app-pagination
              :getList="userList"
              :pageLimit_parent="pageLimit"
              v-if="selectKey != 3 && userList.totalRecords > 15"
            ></app-pagination>
            <app-pagination
              :getList="depositList"
              :pageLimit_parent="pageLimit"
              v-if="selectKey == 3 && depositList.totalRecords > 15"
            ></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import moment from "moment";
import { fxViewMixins } from "@/plugins/fxView";
export default {
  name: "CLIENT-DETAILS",
  mixins: [fxViewMixins],
  data() {
    return {
      pageTitle: this.$options.name,

      pageLoader: false,
      response_msg: "",
      msg_type: "",
      page: "1",
      col_span: 10,
      filterShow: false,
      disable: false,
      openToggle: false,
      submittedRequest: false,
      statInfo: {
        interval: "",
        from: "",
        to: "",
      },

      dashboardOtherData: {},
      totalclient: [],

      filter_selected: "0",
      fromDate: [],
      toDate: "",
      allFilters: [],
      search: "",
      pageLimit: 15,
      selectKey: "0",
      righthand: "verified",
      main: {
        type: "select",
        value: "Status",
        fieldname: "Status",
        conditions: {
          Is: "=",
          "Is Not": "!=",
        },
        optionField: {
          Verified: "verified",
          Active: "active",
          HighRisk: "highrisk",
          Pro: "pro",
          "Completed Registeration": "completed",
          "New Update": "any_unread_for_admin",
        },
      },
      searchString: [],
      fundedAmount: "",
      condition: "!=",
      dateRange: "7",
      mainArray: {
        status: {
          type: "select",
          value: "Status",
          fieldname: "Status",
          conditions: {
            Is: "=",
            "Is Not": "!=",
          },
          optionField: {
            Verified: "verified",
            Active: "active",
            HighRisk: "highrisk",
            "Completed Registeration": "completed",
            "New Update": "any_unread_for_admin",
            Pro: "pro",
          },
        },
        date: {
          type: "date",
          value: "created",
          fieldname: "Created Date",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        OverallDeposit: {
          type: "text",
          value: "total_deposit",
          fieldname: "Overall Deposit",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        Deposit: {
          type: "text",
          value: "highest_deposit",
          fieldname: "Single Deposit",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        withdrwal: {
          type: "text",
          value: "total_withdrawal",
          fieldname: "Overall withdarwal",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            "Is Less Than": ">",
            "Is Greater Than": "<",
          },
        },
        Name: {
          type: "text",
          value: "firstname",
          fieldname: "Name",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            Contains: "contains",
            Not_contains: "not_contains",
            "Starts with": "startwith",
            "Ends with": "endswith",
          },
        },
        email: {
          type: "text",
          value: "email",
          fieldname: "Email",
          conditions: {
            Is: "=",
            "Is Not": "!=",
            Contains: "contains",
            Not_contains: "not_contains",
            "Starts with": "startwith",
            "Ends with": "endswith",
          },
        },
      },
    };
  },
  methods: {
    maxDate() {
      // return moment().format("YYYY-MM-DD");
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(0,0)
      const dd = String(today.getDate()).padStart(0,0);
      return `${yyyy}-${mm}-${dd}`
    },
    eventInterValFl(interval, eventType) {
      if (eventType == "stat") {
        this.statInfo.interval = interval;
        if (this.statInfo.interval != "custom") {
          this.statInfo.from = this.statInfo.to = "";
          this.listing();
        } else if (
          this.statInfo.interval == "custom" &&
          this.statInfo.from != "" &&
          this.statInfo.to != ""
        ) {
          this.listing();
          //this.openToggle = !this.openToggle
        } else if (this.statInfo.interval == "") {
          this.listing();
        }
      }
    },
    getHumanDate(date) {
      return this.$parent.dateDDMMFormat(date);
    },
    resCounFunc(getData) {
      let countryString = [];
      countryString = this.countriesList.filter((list) => list.iso2 == getData);
      return countryString[0].name;
    },
    filter(getData) {
      this.selectKey = getData;
      this.$refs.form.resetdata();
    },
    removeFilter(removeindex) {
      const filterApplied = this.allFilters;

      if (filterApplied.length == 1) {
        this.allFilters.splice(removeindex, 1);
        this.searchString.splice(removeindex, 1);
      } else if (
        filterApplied.length > 1 &&
        removeindex == filterApplied.length - 1
      ) {
        this.allFilters.splice(removeindex - 1, 2);
        this.searchString.splice(removeindex - 1, 2);
      } else {
        this.allFilters.splice(removeindex, 2);
        this.searchString.splice(removeindex, 2);
      }
    },
    and() {
      if (this.condition != "") {
        if (this.condition == "contains") {
          this.righthand = this.righthand.toLowerCase();

          this.condition = 'LIKE "%' + this.righthand + '%"';
          this.righthand = "";
        }
        if (this.condition == "startwith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '%" + this.righthand + "'";
          this.righthand = "";
        }
        if (this.condition == "endswith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '" + this.righthand + "%'";
          this.righthand = "";
        }
        let filterTest = {};
        filterTest.fieldname = this.main.value;
        filterTest.conditions = this.condition;
        filterTest.fieldvalue = this.righthand;

        this.allFilters.push(filterTest);

        this.allFilters.push("and");

        //
        this.searchString.push(
          this.main.value + "  " + this.condition + " " + this.righthand
        );

        // this.searchString.push('and')

        this.main = {};
        this.condition = "";
        this.righthand = "";
      }
    },
    or() {
      if (this.condition != "") {
        if (this.condition == "contains") {
          this.righthand = this.righthand.toLowerCase();

          this.condition = 'LIKE "%' + this.righthand + '%"';
          this.righthand = "";
        }
        if (this.condition == "startwith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '%" + this.righthand + "'";
          this.righthand = "";
        }
        if (this.condition == "endswith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '" + this.righthand + "%'";
          this.righthand = "";
        }
        let filterTest = {};
        filterTest.fieldname = this.main.value;
        filterTest.conditions = this.condition;
        filterTest.fieldvalue = this.righthand;
        this.allFilters.push(filterTest);
        this.allFilters.push("or");

        // this.searchString.push('or')
        //thi
        this.searchString.push(
          this.main.value + "  " + this.condition + " " + this.righthand
        );

        this.main = {};
        this.condition = "";
        this.righthand = "";
      }
    },
    searchFilter() {
      if (this.condition !== "") {
        if (this.allFilters.length > 0) {
          if (typeof this.allFilters[this.allFilters.length - 1] == "object") {
            this.allFilters.push("and");
            this.searchString.push("and");
          }
        }
        if (this.condition == "contains") {
          this.righthand = this.righthand.toLowerCase();

          this.condition = 'LIKE "%' + this.righthand + '%"';
          this.righthand = "";
        }
        if (this.condition == "startwith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '%" + this.righthand + "'";
          this.righthand = "";
        }
        if (this.condition == "endswith") {
          this.righthand = this.righthand.toLowerCase();
          this.condition = "LIKE '" + this.righthand + "%'";
          this.righthand = "";
        }
        let filterTest = {};
        filterTest.fieldname = this.main.value;
        filterTest.conditions = this.condition;
        filterTest.fieldvalue = this.righthand;
        this.allFilters.push(filterTest);

        this.searchString.push(
          this.main.value + "  " + this.condition + " " + this.righthand
        );

        // this.main = {}
        // this.condition = ''
        // this.righthand = ''
      }

      if (this.condition == "") {
        if (this.allFilters.length > 0) {
          if (typeof this.allFilters[this.allFilters.length - 1] !== "object") {
            this.allFilters.splice(-1, 1);
            this.searchString.splice(-1, 1);
          }
        }
      }

      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
        },
        localParams: { parameter: this },
      };
      inputJson.globalParams.filter = this.allFilters;

      this._runGetUserList(inputJson);

      //console.log(this.allFilters)
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
          stat_interval: this.statInfo.interval,
          stat_from_interval: this.statInfo.from,
          stat_to_interval: this.statInfo.to,
        },
        localParams: { parameter: this },
      };
      if (this.selectKey == "1") {
        inputJson.globalParams.filter["session.verified_status"] = "2";
      } else if (this.selectKey == "2") {
        //passed the string for backend condition as 0 != ""
        inputJson.globalParams.filter["session.verified_status"] = "0";
      } else if (this.selectKey == "4") {
        inputJson.globalParams.filter["session.verified_status"] = "4";
      }
      this._runGetUserList(inputJson);
    },
    depositListing() {
      let inputJson = {
        globalParams: {
          filter: { "deposit.payment_status": 1 },
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
        },
        localParams: { parameter: this },
      };
      this._runGetDepositList(inputJson);
    },
    csvExport(arrData, type, getFileName) {
      let csv = "data:text/csv;charset=utf-8,";
      //console.log("data",arrData)

      const _that = this;
      csv +=
        "Registration Date,Client Name,Email,Country,Sub-Aff. Name,Volume Traded,Total Commission,Sub-Affiliate Comm.,My Comm.,Status \n";
      arrData.forEach(function (row) {
        let RMname =
          _that.get_user.id != row.admin_id &&
          row.RMname != "" &&
          row.RMname != null
            ? row.RMname
            : "-";
        let status = row.status == 1 ? "Active" : "Inactive";
        csv +=
          _that.getHumanDate(row.created) +
          "," +
          row.firstname +
          "," +
          row.email +
          "," +
          row.country +
          "," +
          RMname +
          "," +
          row.totalVolume +
          "," +
          row.totalRevenue +
          "," +
          row.subIbCommission +
          "," +
          row.myCommission +
          "," +
          status;
        csv += "\n";
      });

      const link = document.createElement("a");
      const data = encodeURI(csv);
      link.setAttribute("href", data);
      link.setAttribute("download", getFileName);
      //console.log("link",link)

      link.click();
    },
  },
  created() {
    this._runApiDashboardData({
      globalParams: {},
      localParams: { parameter: this },
    });
    this.setData(this.pageTitle);
    this.listing();
    
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/client/client_details.vue